import { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
import { api } from '../api';

/* =====================================================================
   La línea del catálogo geográfico · MAESTRA I.1.8 (IM-5)
   =====================================================================
   Va en Ajustes → Este servidor, que es donde se mira qué versión de qué
   cosa corre aquí: «Catálogo geográfico: versión 2026-09 · fuente
   INEGI/SEPOMEX · cargado el …». El catálogo viaja dentro de la imagen y
   se carga solo al arrancar si cambió; esta línea dice cuál quedó.
   Cargarlo a mano (quien trae el archivo en una memoria) sigue en «Los
   lugares que TEGO conoce», dentro de «Traer lo que ya tienes».
   ===================================================================== */
export default function CatalogoGeografico() {
  const [carga, setCarga] = useState(null);
  const [disponible, setDisponible] = useState(null);
  const [fallo, setFallo] = useState(false);

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const [c, d] = await Promise.all([
          api.get('/geografia/carga'),
          api.get('/geografia/catalogo/disponible'),
        ]);
        if (vivo) { setCarga(c); setDisponible(d); }
      } catch {
        if (vivo) setFallo(true);
      }
    })();
    return () => { vivo = false; };
  }, []);

  if (fallo || !carga) return null;

  const version = carga.fecha_corte
    ? carga.fecha_corte.slice(0, 7)
    : (carga.nombre_archivo || 'sin fecha de corte');
  const fuente = carga.fuente === 'SEPOMEX' || !carga.fuente
    ? 'INEGI/SEPOMEX' : carga.fuente;
  const cargadoEl = carga.cargado_en
    ? new Date(carga.cargado_en).toLocaleString('es-MX', {
      day: 'numeric', month: 'long', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    })
    : null;

  return (
    <section className="rounded-xl border border-gray-200 p-4">
      <div className="flex items-start gap-3">
        <div className="rounded-xl bg-gray-100 p-2">
          <MapPin className="h-5 w-5 text-gray-500" aria-hidden="true" />
        </div>
        <div className="flex-1 text-sm">
          <h2 className="font-semibold text-gray-900">Catálogo geográfico</h2>
          {carga.cargado ? (
            <p className="text-gray-700">
              Versión <strong>{version}</strong> · fuente {fuente} · cargado
              el {cargadoEl} · {carga.municipios} municipios y{' '}
              {carga.asentamientos} colonias.
            </p>
          ) : (
            <p className="text-gray-700">
              Sin cargar. Los estados están; los municipios y códigos
              postales llegan con el archivo de Correos de México, que viaja
              en cada versión de TEGO o se sube desde «Los lugares que TEGO
              conoce».
            </p>
          )}
          {disponible?.hay && !disponible.ya_cargado && (
            <p className="mt-1 text-amber-800">
              Esta versión trae uno más nuevo ({disponible.fecha_corte}) que
              falta cargar: se carga solo al arrancar TEGO, o
              desde «Los lugares que TEGO conoce».
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
